import React, { useEffect, useState } from 'react';
import { Modal, Button, Upload, message, Row, Col, Typography, Divider, Select } from 'antd';
import { UploadOutlined, DownloadOutlined, InboxOutlined, DeleteFilled } from '@ant-design/icons';
import axios from 'axios';
import './index.css';
import { apiDownloadTemplate } from '@services/ManageDevices/DeviceServices';
import { downloadBlobFile, uploadBlobFile } from '@utils/utils';
import { URL_API } from '@configs/index';
import { showError } from '@components/notification';
import { SelectCommunity } from '@page/Common/SelectCommunity';

const { Text } = Typography;

const ModalImportFile = ({ visible, onCancel }) => {
  const [file, setFile] = useState(null);
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [importType, setImportType] = useState('device'); // 'device' or 'status'
  const handleDownload = async () => {
    try {
      setLoadingTemplate(true);
      const endpoint =
        importType === 'device'
          ? `${URL_API}/api/devices/export-template`
          : `${URL_API}/api/devices/export-status-template`;
      const fileName =
        importType === 'device'
          ? 'File mẫu import thiết bị.xlsx'
          : 'File mẫu import trạng thái thiết bị.xlsx';

      await downloadBlobFile(endpoint, fileName, null, 'POST');
    } catch (e) {
      showError('Có lỗi xảy ra, vui lòng liên hệ ban quản trị');
    } finally {
      setLoadingTemplate(false);
    }
  };

  const beforeUpload = (file) => {
    setFile(file);
    return false;
  };
  const [loadingImport, setLoadingImport] = useState(false);
  const handleSubmit = async () => {
    try {
      setLoadingImport(true);
      if (!file) {
        message.warning('Bạn phải chọn file trước khi nhập!');
        return;
      }

      const formData = new FormData();
      formData.append('file', file);

      if (importType === 'device') {
        formData.append('community', selectedCommunity);
      }

      const endpoint =
        importType === 'device'
          ? `${URL_API}/api/devices/import`
          : `${URL_API}/api/devices/import-status`;

      await uploadBlobFile(endpoint, 'Kết quả.xlsx', formData);
      onCancel();
    } catch (e) {
      console.log(e);
      showError('Có lỗi xảy ra, vui lòng liên hệ ban quản trị');
    } finally {
      setLoadingImport(false);
    }
  };

  const handleRemove = () => {
    setFile(null);
  };

  useEffect(() => {
    setSelectedCommunity('HP');
    setFile(null);
    setImportType('device');
  }, [visible]);

  return (
    <Modal
      title="Nhập dữ liệu từ file excel"
      visible={visible}
      loading={loadingImport}
      onCancel={() => {
        setFile(null);
        onCancel();
      }}
      footer={[
        <Button
          disabled={importType === 'device' && !selectedCommunity}
          key="submit"
          type="primary"
          onClick={handleSubmit}
          style={{
            color: '#fff',
            height: '36px',
            backgroundColor: '#0284c7',
            borderColor: '#0284c7',
            fontSize: '18px'
          }}>
          Nhập dữ liệu
        </Button>
      ]}>
      <Row gutter={[16, 16]} style={{ marginTop: '0px' }}>
        <Col span={24}>
          <Typography.Text>Loại import: </Typography.Text>
          <Select
            value={importType}
            onChange={(value) => {
              setImportType(value);
              setFile(null);
              if (value === 'status') {
                setSelectedCommunity('dummy'); // Status import doesn't need community
              } else {
                setSelectedCommunity(null);
              }
            }}
            style={{ width: '100%', marginTop: '8px' }}>
            <Select.Option value="device">Import thêm mới/cập nhật thiết bị</Select.Option>
            <Select.Option value="status">
              Import cập nhật trạng thái (Bảo hành / Không dùng được / Lưu kho / Xoá)
            </Select.Option>
          </Select>
        </Col>
        {importType === 'device' && !selectedCommunity ? (
          <>
            <Typography.Text>Chọn chi nhánh: </Typography.Text>
            <SelectCommunity
              value={selectedCommunity}
              onChange={setSelectedCommunity}
              isAll={false}
            />
          </>
        ) : importType === 'device' ? (
          <>
            <Col span={24}>
              <Button
                loading={loadingTemplate}
                type="link"
                icon={<DownloadOutlined />}
                onClick={handleDownload}
                block
                style={{
                  color: '#0284c7',
                  fontSize: '18px'
                }}>
                Tải về file mẫu
              </Button>
            </Col>
            <Col span={24}>
              {!file ? (
                <Upload.Dragger beforeUpload={beforeUpload} showUploadList={false}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Nhấn hoặc thả file vào để tải lên</p>
                  <p className="ant-upload-hint">Vui lòng chỉ tải file excel dạng .xlsx</p>
                </Upload.Dragger>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '20px 0'
                  }}>
                  <Text strong>{file.name}</Text>
                  <Button
                    type="link"
                    icon={<DeleteFilled style={{ color: '#0284c7', fontSize: '18px' }} />}
                    onClick={handleRemove}></Button>
                </div>
              )}
            </Col>
          </>
        ) : (
          <>
            <Col span={24}>
              <Button
                loading={loadingTemplate}
                type="link"
                icon={<DownloadOutlined />}
                onClick={handleDownload}
                block
                style={{
                  color: '#0284c7',
                  fontSize: '18px'
                }}>
                Tải về file mẫu
              </Button>
            </Col>
            <Col span={24}>
              {!file ? (
                <Upload.Dragger beforeUpload={beforeUpload} showUploadList={false}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Nhấn hoặc thả file vào để tải lên</p>
                  <p className="ant-upload-hint">Vui lòng chỉ tải file excel dạng .xlsx</p>
                </Upload.Dragger>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '20px 0'
                  }}>
                  <Text strong>{file.name}</Text>
                  <Button
                    type="link"
                    icon={<DeleteFilled style={{ color: '#0284c7', fontSize: '18px' }} />}
                    onClick={handleRemove}></Button>
                </div>
              )}
            </Col>
          </>
        )}
      </Row>
    </Modal>
  );
};

export default ModalImportFile;
